import { Entity, IEntity } from '@lycoris-nubila/ngx-lycoris';
import { Observable, of } from 'rxjs';

import {
	CvTemplateI18n,
	ICvTemplateI18n,
} from 'domain/template/cv/cv-template-i18n';

export interface ICvTemplate extends IEntity {
	readonly organizationId: string;
	readonly localizations: ReadonlyArray<ICvTemplateI18n>;
	readonly localization$: Observable<ICvTemplateI18n>;
}

export class CvTemplate extends Entity implements ICvTemplate {
	private _organizationId: string;
	private _localizations: CvTemplateI18n[];
	private _localization$: Observable<CvTemplateI18n>;

	constructor(
		id: string,
		organizationId: string,
		updateTimestamp: number,
		creationTimestamp: number,
		localizations: CvTemplateI18n[],
		localization$: Observable<CvTemplateI18n> = of(null)
	) {
		super(id, creationTimestamp, updateTimestamp);
		this._organizationId = organizationId;
		this._localizations = localizations;
		this._localization$ = localization$;
	}

	public get organizationId(): string {
		return this._organizationId;
	}

	public get localizations(): CvTemplateI18n[] {
		return this._localizations;
	}

	public get localization$(): Observable<CvTemplateI18n> {
		return this._localization$;
	}
}
